module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp12_8019.c35c10dc.png";